import React, {useEffect, useState} from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
} from '@mui/material';

const AliasEditorDialog = ({
                               open,
                               saving,
                               error,
                               onCancel,
                               onSubmit,
                           }) => {
    const [alias, setAlias] = useState('');
    const [touched, setTouched] = useState(false);

    useEffect(() => {
        if (!open) return;
        setAlias('');
        setTouched(false);
    }, [open]);

    const trimmedAlias = alias.trim();
    const aliasError = touched && !trimmedAlias ? 'Alias is required' : null;

    const handleSubmit = async () => {
        setTouched(true);
        if (!trimmedAlias) return;

        try {
            await onSubmit?.(trimmedAlias);
        } catch (submitError) {
            // Keep dialog open so user can retry.
        }
    };

    return (
        <Dialog open={open} onClose={saving ? undefined : onCancel} maxWidth="sm" fullWidth>
            <DialogTitle>Add alias</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{pt: 1}}>
                    {error && (
                        <Alert severity="error">
                            {error.message || 'Failed to add alias.'}
                        </Alert>
                    )}
                    <TextField
                        label="Alias"
                        placeholder="e.g. Republic of Korea"
                        value={alias}
                        onChange={(event) => setAlias(event.target.value)}
                        onBlur={() => setTouched(true)}
                        error={Boolean(aliasError)}
                        helperText={aliasError || 'Alternate name for this entity'}
                        autoFocus
                        fullWidth
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} disabled={saving}>Cancel</Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={saving || !trimmedAlias}
                >
                    {saving ? 'Creating...' : 'Create alias'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AliasEditorDialog;
